(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["silky-collection-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('silky-collection-tabs')) {
    customElements.define('silky-collection-tabs', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        const tabs = [...this.querySelectorAll('[role="tab"]')];
        const activate = (tab, focus = false) => {
          tabs.forEach(item => {
            const active = item === tab;
            item.setAttribute('aria-selected', String(active));
            item.tabIndex = active ? 0 : -1;
            this.querySelector('[id="' + item.getAttribute('aria-controls') + '"]').hidden = !active;
          });
          if (focus) tab.focus();
        };
        tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => activate(tab));
          tab.addEventListener('keydown', event => {
            let target;
            if (event.key === 'ArrowRight') target = (index + 1) % tabs.length;
            if (event.key === 'ArrowLeft') target = (index - 1 + tabs.length) % tabs.length;
            if (event.key === 'Home') target = 0;
            if (event.key === 'End') target = tabs.length - 1;
            if (target !== undefined) { event.preventDefault(); activate(tabs[target], true); }
          });
        });
        this.addEventListener('shopify:block:select', event => {
          const panel = event.target.closest('[role="tabpanel"]');
          const tab = tabs.find(item => item.getAttribute('aria-controls') === panel?.id);
          if (tab) activate(tab);
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
